import { LOCALSTORAGE_KEYS } from '@features/General'
import { Action } from 'redux'
import { put, takeLatest, all } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IListQueryPaginationPayload, IListSearchQueryPaginationPayload } from '@app-store/slices/events/list'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}
interface TaskSearchAction extends Action {
    payload: IListSearchQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure, onRequestSearch, onFailureSearch, onSuccessSearch } = rootActions.events.list

function* listSagaTask({ payload }: TaskAction) {
    try {
        const params = {
            ...payload.pagination,
            query: payload.query
        }

        const response = yield axios.get(`/event`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            localStorage.setItem(LOCALSTORAGE_KEYS.EVENT_LIST, JSON.stringify(response.result.data))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* searchSagaTask({ payload }: TaskSearchAction) {
    try {
        const params = {
            ...payload.pagination,
            search: payload.search
        }

        const response = yield axios.get(`/event/search`, {
            params
        })
        if (response.success) {
            yield put(onSuccessSearch(response.result))
        }
    } catch (error) {
        yield put(onFailureSearch(error))
    }
}

function* listSaga(): any {
    yield all([
        takeLatest<TaskAction>(onRequest, listSagaTask),
        takeLatest<TaskSearchAction>(onRequestSearch, searchSagaTask)
    ])
}

export default listSaga
